// extracted by mini-css-extract-plugin
export default {"root":"PZ4GODk_832drTvKK2Co","link":"E9Ti6ak_QIT5WULbv4qr","preview":"ou1ota3moSz3Sdz5LtEv","name":"BtEzeEL3YFJd01w4vpNy","placeHolderShimmer":"SV_6AdZYE9jMDiyFKa_Q"};